import React, { useContext} from 'react'
import TicketItem from '../ticketItem/TicketItem'
import { TicketsContext } from '../../context/ticketsContext';

const TicketList = () => {
    const {ticketsData} = useContext(TicketsContext)

    if (!ticketsData) {
        return (
            <h2>Нет билетов</h2>
        )
    }
    return (
        <div className='ticket-list'>
            {
                ticketsData.slice(1, 11).map((item) => {
                    return (
                        <div key={item.price}>
                            <TicketItem {...item} />
                        </div>
                    )
                })
            }
        </div>
    )
}

export default TicketList
